import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Form, Button, Card } from "react-bootstrap";
import { LOCATION_ID, TOKEN, API_URL } from "..";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { formatPhoneNumber } from "../helpers/phoneUtils";

const AddCustomerPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // loader ON
    const currentUser = JSON.parse(localStorage.getItem('user'));

    try {
      const response = await fetch(`${API_URL}/api/customer/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          phone: formatPhoneNumber(formData.phone),
          locationId: LOCATION_ID,
          addedby: currentUser.crm_id,
          token: TOKEN,
        }),
      });

      const result = await response.json();

      if (result.success) {
        // 3 seconds loader dikhane ke baad navigate
        setTimeout(() => {
          setLoading(false); // loader OFF
          window.location.href = "/customer"
        }, 3000);
      } else {
        setLoading(false);
        alert("Error: " + result.message);
      }
    } catch (error) {
      setLoading(false);
      alert("Something went wrong!");
    }
  };


  return (
    <MasterLayout>
      <Breadcrumb title="Add New Customer" />

      <Card className="p-24 shadow-sm" style={{ maxWidth: "900px", margin: "auto" }}>
        <h4 className="mb-4 text-center">Customer Information</h4>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>First Name *</Form.Label>
            <Form.Control
              required
              type="text"
              value={formData.firstName}
              onChange={(e) => handleChange("firstName", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              value={formData.lastName}
              onChange={(e) => handleChange("lastName", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              required
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="text"
              value={formData.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
            />
          </Form.Group>

          <Button variant="primary" type="submit" disabled={loading} className="w-100">
            {loading ? "Saving..." : "Save Customer"}
          </Button>
        </Form>
      </Card>
    </MasterLayout>
  );
};

export default AddCustomerPage;
